// src/App.js
import React, { useState } from 'react';
import { GoogleOAuthProvider } from '@react-oauth/google'; // Import the provider
import GoogleAuth from '../../components/Navigation/GoogleAuthentication'; // Your custom GoogleAuth component
import { LoginUserViaGoogle } from '../../services/auth';

const GoogleAuthentication = () => {
  const [user, setUser] = useState(null);

  const handleLoginSuccess = async (credential) => {
    try {
      // Send the credential to your backend server for verification
      const response = await LoginUserViaGoogle(credential)

      const data = response.data
      
      console.log('data',data);
      if (data.user) {
        setUser(data.user);
      } else {
        console.error("Failed to authenticate");
      }
    } catch (error) {
      console.error("Error during login:", error);
    }
  };

  const handleSignOut = () => {
    setUser(null);
  };

  return (
    <div className='googleauthcontainer'>
    <GoogleOAuthProvider clientId="740170205622-q5ccc4ck91h3f1daf617dp6kd0rhrh25.apps.googleusercontent.com">
      <div className='googlesubauthcontainer'>
        {!user ? (
          <GoogleAuth onLoginSuccess={handleLoginSuccess} />
        ) : (
          <div>
            <h1>Welcome, {user.name}</h1>
            <img src={user.picture} alt="profile" />
            <p>Email: {user.email}</p>
            <button onClick={handleSignOut}>Sign Out</button>
          </div>
        )}
      </div>
    </GoogleOAuthProvider>
    </div>
  );
};

export default GoogleAuthentication;
